<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title27"></a>
<div class="p-c"><span><strong class="b">IN MEMORIAM<br/> ALAN HENRY WOOD<br/> 
1941–2003</strong></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429910415_ded01.vue?6b907e97